import { render, staticRenderFns } from "./SessionBlocksPerformance.vue?vue&type=template&id=63c34163&scoped=true&"
import script from "./SessionBlocksPerformance.vue?vue&type=script&lang=js&"
export * from "./SessionBlocksPerformance.vue?vue&type=script&lang=js&"
import style0 from "./SessionBlocksPerformance.vue?vue&type=style&index=0&id=63c34163&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c34163",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
